import { Component } from 'react';
import PropTypes from 'prop-types';
import { Row, Col } from 'react-bootstrap';
import PageDivider from '../divider';
import {history} from '../../../store';

class ArticlesList extends Component {
  render() {
    return (
      <div className="article-list">
        {this.props.articles.map(article => (
          <div key={article.id}>
            <br />
            <div
              className="article-title-link"
              onClick={() => {
              history.push(`/article/${article.id}`);
            }}
            >
              <Row className="article-container">
                <Col lg={12} className="article-right-col">
                  <div className="article-item">
                    <img src={article.link.image} className="article-img"/>
                  </div>
                  <div className="article-title">
                    {article.title}
                  </div>
                </Col>
              </Row>
            </div>
            <PageDivider/>
          </div>
        ))}
      </div>
    );
  }
}

ArticlesList.propTypes = {
  articles: PropTypes.array.isRequired
};

export default ArticlesList;
